import {makeStyles} from "@mui/styles";

export const useStyles = makeStyles({
  infoIcon: {
    position: 'relative',
    marginLeft: 4,
    top: -5,
  }
});
